import React, { useState, useEffect } from 'react'
import { Layout, Button, Space, PageHeader, Form, Input, Row, Checkbox, DatePicker, Spin, Col } from 'antd';
import { UploadOutlined } from "@ant-design/icons";
import R2Footer from '../../components/Footer';
import { useHistory, useParams } from "react-router";
import MenuService from '../../services/MenuService';
import Dragger from 'antd/lib/upload/Dragger';
import Spinner from '../../components/Layout/Spinner';

const { Content } = Layout;

const MenuItemForm = () => {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const history = useHistory();
    const params = useParams();
    const [form] = Form.useForm();

    useEffect(() => {
        checkMenuItem();
    }, []);

    const checkMenuItem = async () => {
        if(params.menuItemId) {
            setLoading(true);
            const menuItem = await MenuService.getMenuItem(parseInt(params.menuItemId));
            form.setFieldsValue(menuItem);
            setLoading(false);
        }
    }

    const submitFile = (info) => {
        setFile(info.file);
    }

    const submitForm = async (menuItem) => {
        setLoading(true);
        const formData = new FormData();
        if(file) {
            formData.append('file', file.originFileObj);
        }
        const urlResponse = await MenuService.uploadMenuItemPhoto(formData);  
    
            
        if(params.menuItemId) {
            const responseUpdate = await MenuService.updateMenuItem({
                ...menuItem,
                menu_id: parseInt(params.menuId),
                size: "1",
                prep_time_minutes: menuItem.prep_time_minutes ? parseInt(menuItem.prep_time_minutes) : null,
                regular_max_quantity: menuItem.regular_max_quantity ? parseInt(menuItem.regular_max_quantity) : null,
                photo_url: urlResponse?urlResponse.url:""
            },params.menuItemId);
        } else {
            const response = await MenuService.addMenuItem({
            ...menuItem,
            menu_id: parseInt(params.menuId),
            size: "1",
            prep_time_minutes: menuItem.prep_time_minutes ? parseInt(menuItem.prep_time_minutes) : null,
            regular_max_quantity: menuItem.regular_max_quantity ? parseInt(menuItem.regular_max_quantity) : null,
            photo_url: urlResponse?urlResponse.url:""
        });
    }
        
        setLoading(false);
        form.resetFields();
        history.goBack()
    }

    const onError = (errorInfo) => {
        console.log(errorInfo);
    }

    return (
        <Layout style={{ padding: '0 24px 24px' }}>
            <Content
                className="site-layout-background page-padding"
                style={{
                   
                    margin: '16px 0px',
                    minHeight: 280,
                }}
            >
                <Space direction="vertical" style={{ width: '100%' }}>
                    <PageHeader
                        title={params.menuItemId?"Edit Menu Item":"Add Menu Item"}
                        onBack={() => history.goBack()} />
                    {
                        loading ?
                            <Spinner />
                            :
                                
                            <Form onFinish={submitForm} form={form} onFinishFailed={onError}>
                                <Row gutter={[24]}>
                                    <Col span={6}>
                                        <Form.Item name="photo_url" style={{ textAlign: 'left' }} className="block">
                                        {/* <Upload onChange={}>
                                            <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                        </Upload> */}
                                            <Dragger onChange={submitFile} onDrop={submitFile} maxCount={1}>
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined />
                                                </p>
                                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                                <p className="ant-upload-hint">
                                                    Please upload image files with .JPG and .PNG extension only
                                                </p>
                                            </Dragger>
                                        </Form.Item>
                                    </Col>
                                    <Col span={18}>
                                        <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please provide the menu name' }]}>
                                            <Input placeholder="Provide the menu name" />
                                        </Form.Item>
                                        <Form.Item label="Description" name="description" style={{ textAlign: 'left' }}>
                                            <Input type="text" placeholder="Provide the menu description" />
                                        </Form.Item>
                                        <Form.Item label="Price" name="price" rules={[{ required: true, message: 'Please provide the menu item price' }]}>
                                            <Input type="number" placeholder="Provide the menu item price" />
                                        </Form.Item>
                                        <Form.Item label="Prep Time (in minutes)" name="prep_time_minutes">
                                            <Input type="number" placeholder="Provide the prep time in minutes" />
                                        </Form.Item>
                                        <Form.Item valuePropName="checked" label="Vegetarian" name="is_vegetarian" style={{ textAlign: 'left' }}>
                                            <Checkbox onChange={() => { }}>Please select if this menu item will be vegetarian</Checkbox>
                                        </Form.Item>
                                        <Form.Item valuePropName="checked" label="Gluten Free" name="is_gluten_free" style={{ textAlign: 'left' }}>
                                            <Checkbox onChange={() => { }}>Please select if this menu item will be gluten free</Checkbox>
                                        </Form.Item>
                                        <Form.Item valuePropName="checked" label="Vegan" name="is_vegan" style={{ textAlign: 'left' }}>
                                            <Checkbox onChange={() => { }}>Please select if this menu item will be vegan</Checkbox>
                                        </Form.Item>
                                        <Form.Item label="Max quantity for regular order" name="regular_max_quantity">
                                            <Input type="number" placeholder="Provide the maximum quantity for this item to be considered a regular order" />
                                        </Form.Item>
                                        <Button type="primary" htmlType="submit" size='large'>
                                            Save
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                    }
                </Space>
            </Content>
            <R2Footer />
        </Layout>
    )
}

export default MenuItemForm;